import { render, staticRenderFns } from "./CreateRetailer.vue?vue&type=template&id=8ca48570&"
import script from "./CreateRetailer.vue?vue&type=script&lang=js&"
export * from "./CreateRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports